/* Famgraving — página de producto nueva (fg-pdp). Oferta Klaviyo, carrusel de reseñas,
   fecha estimada de entrega (hora de Florida, días hábiles) y videos de clientes. */
(function () {
  if (window.__fgpInit) return;
  window.__fgpInit = true;

  var TZ = 'America/New_York';
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  // Fecha/hora actual en Florida, como fecha "local" sin zona
  function nowET() {
    var p = {};
    new Intl.DateTimeFormat('en-US', { timeZone: TZ, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23' })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return new Date(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
  }
  function isBiz(d) { var w = d.getDay(); return w !== 0 && w !== 6; }
  function addBiz(d, n) {
    var r = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    while (n > 0) { r.setDate(r.getDate() + 1); if (isBiz(r)) n--; }
    return r;
  }
  function fmt(d) { return MONTHS[d.getMonth()] + ' ' + d.getDate(); }
  function range(a, b) {
    if (a.getTime() === b.getTime()) return fmt(a);
    if (a.getMonth() === b.getMonth()) return fmt(a) + '–' + b.getDate();
    return fmt(a) + ' – ' + fmt(b);
  }

  function initShip(el) {
    var cutoff = parseInt(el.dataset.cutoff, 10);
    var mk = [parseInt(el.dataset.makeMin, 10), parseInt(el.dataset.makeMax, 10)];
    var tr = [parseInt(el.dataset.transitMin, 10), parseInt(el.dataset.transitMax, 10)];
    var lead = el.querySelector('[data-fgp-lead]');
    function paint() {
      var now = nowET();
      var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var cut = new Date(today.getTime()); cut.setHours(cutoff, 0, 0, 0);
      var startsToday = isBiz(today) && now < cut;
      // Día en que arranca la producción
      var start = startsToday ? today : addBiz(today, 1);
      var shipA = addBiz(start, mk[0]), shipB = addBiz(start, mk[1]);
      var delA = addBiz(shipA, tr[0]), delB = addBiz(shipB, tr[1]);
      el.querySelector('[data-fgp-d="ship"]').textContent = range(shipA, shipB);
      el.querySelector('[data-fgp-d="deliver"]').textContent = range(delA, delB);
      if (startsToday) {
        var mins = Math.max(1, Math.round((cut - now) / 60000));
        var h = Math.floor(mins / 60), m = mins % 60;
        lead.innerHTML = 'Order within <strong>' + (h ? h + 'h ' : '') + m + 'm</strong> and we start making it <strong>today</strong>.';
      } else {
        var day = (start.getTime() - today.getTime()) / 864e5 === 1 ? 'tomorrow' : DAYS[start.getDay()];
        lead.innerHTML = 'Order now and we start making it <strong>' + day + '</strong>.';
      }
    }
    paint();
    setInterval(paint, 30000);
  }

  function initSlider(el) {
    var slides = el.querySelectorAll('.fgp-review__slide');
    if (slides.length < 2) return;
    var i = 0, timer;
    function go(n) {
      slides[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
    }
    function auto() { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, 6000); }
    el.querySelector('[data-fgp-next]').addEventListener('click', function () { go(i + 1); auto(); });
    el.querySelector('[data-fgp-prev]').addEventListener('click', function () { go(i - 1); auto(); });
    auto();
  }


  // ---------- Descripción en secciones desplegables ----------
  // Las descripciones vienen de Etsy/Amazon con formatos distintos: títulos en <strong>, en
  // letras "𝐁𝐎𝐋𝐃" de Unicode, en MAYÚSCULAS o en <h3>, casi siempre separados con <br>.
  // Se parte todo en líneas, se detectan los títulos y cada uno abre un desplegable igual a
  // los de "Shipping & Returns". Lo que va antes del primer título queda visible (con "Read more").
  var SMALL = /^(a|an|and|the|of|for|to|in|on|with|or|at|by)$/i;
  function norm(t) { return (t || '').normalize('NFKC').replace(/\s+/g, ' ').trim(); }
  function cleanTitle(t) {
    t = norm(t).replace(/^[^A-Za-z0-9]+/, '').replace(/[:\s]+$/, '');
    if (t === t.toUpperCase()) {
      t = t.toLowerCase().split(' ').map(function (w, i) { return (i && SMALL.test(w)) ? w : w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
    }
    return t.replace(/\bFaq\b/, 'FAQ');
  }
  function isTitle(el) {
    if (/^H[1-6]$/.test(el.tagName)) return true;
    if (el.tagName === 'UL' || el.tagName === 'OL' || el.tagName === 'TABLE') return false;
    var raw = (el.textContent || '').replace(/\s+/g, ' ').trim();
    var t = norm(raw);
    if (!t || t.length > 50) return false;
    if (/^[•✔✅☑✓\-–—*·]|^\d+[.)]/.test(t)) return false;
    var letters = t.replace(/[^A-Za-z]/g, '');
    if (letters.length < 3) return false;
    // Todo en negrita (<strong>/<b>)
    var bold = Array.prototype.map.call(el.querySelectorAll('strong, b'), function (b) { return b.textContent; }).join('').replace(/\s+/g, ' ').trim();
    if (bold && norm(bold) === t) return true;
    // Letras "negrita" de Unicode (no hay ninguna letra ASCII normal)
    if (!/[A-Za-z]/.test(raw)) return true;
    // Todo en mayúsculas
    return letters === letters.toUpperCase();
  }
  function splitLines(desc) {
    var out = [];
    Array.prototype.forEach.call(desc.childNodes, function (node) {
      if (node.nodeType === 3) { if (node.textContent.trim()) { var p0 = document.createElement('p'); p0.textContent = node.textContent; out.push(p0); } return; }
      if (node.nodeType !== 1) return;
      if (/^(H[1-6]|UL|OL|TABLE|IMG|IFRAME|VIDEO)$/.test(node.tagName) || !node.querySelector('br')) { out.push(node.cloneNode(true)); return; }
      var cur = document.createElement('p');
      Array.prototype.forEach.call(node.childNodes, function (c) {
        if (c.nodeName === 'BR') { if (cur.textContent.trim()) out.push(cur); cur = document.createElement('p'); }
        else cur.appendChild(c.cloneNode(true));
      });
      if (cur.textContent.trim()) out.push(cur);
    });
    return out.filter(function (el) { return el.tagName === 'IMG' || (el.textContent || '').trim() || el.querySelector('img'); });
  }
  function initDescription(desc) {
    if (desc.dataset.fgpDone) return;
    desc.dataset.fgpDone = '1';
    var lines = splitLines(desc);
    var intro = [], groups = [], g = null;
    lines.forEach(function (el) {
      if (isTitle(el)) { g = { el: el, title: cleanTitle(el.textContent), body: [] }; groups.push(g); }
      else if (g) g.body.push(el);
      else intro.push(el);
    });
    // Si la descripción arranca con un título (casi siempre el nombre del producto), ese primer
    // bloque es la introducción, no un desplegable.
    if (!intro.length && groups.length && groups[0].el === lines[0]) {
      var first = groups.shift();
      intro = [first.el].concat(first.body);
    }
    // "How to Order" no va en la página (María, 27-sep-2026): el menú de personalización ya guía la compra.
    groups = groups.filter(function (x) { return x.body.length && !/^how to order$/i.test(x.title); });
    if (!groups.length && norm(desc.textContent).length < 320) return;
    var caret = document.querySelector('.product__accordion summary .icon-caret');
    var frag = document.createDocumentFragment();
    var introBox = document.createElement('div');
    introBox.className = 'fgp-desc__intro';
    (groups.length ? intro : lines).forEach(function (el) { introBox.appendChild(el); });
    if (introBox.childNodes.length) {
      frag.appendChild(introBox);
      if (norm(introBox.textContent).length > 260) {
        introBox.classList.add('is-clamped');
        var more = document.createElement('button');
        more.type = 'button'; more.className = 'fgp-desc__more'; more.textContent = 'Read more';
        more.addEventListener('click', function () {
          var open = introBox.classList.toggle('is-clamped');
          more.textContent = open ? 'Read more' : 'Read less';
        });
        frag.appendChild(more);
      }
    }
    groups.forEach(function (x) {
      var wrap = document.createElement('div');
      wrap.className = 'product__accordion accordion fgp-desc__acc';
      var det = document.createElement('details');
      var sum = document.createElement('summary');
      sum.innerHTML = '<div class="summary__title"><h2 class="h4 accordion__title"></h2></div>';
      sum.querySelector('h2').textContent = x.title;
      if (caret) sum.appendChild(caret.cloneNode(true));
      var body = document.createElement('div');
      body.className = 'accordion__content rte';
      x.body.forEach(function (el) { body.appendChild(el); });
      det.appendChild(sum); det.appendChild(body); wrap.appendChild(det);
      frag.appendChild(wrap);
    });
    desc.innerHTML = '';
    desc.appendChild(frag);
    desc.classList.add('fgp-desc');
  }


  // ---------- Vista previa del diseño elegido (Globo Product Options) ----------
  // El producto trae en el metafield custom.design_previews un JSON {"1": url, "2": url, ...}.
  // Cuando la clienta elige una opción de Globo que empieza con ese número ("2. Grill Master…")
  // o que coincide con el texto completo, se muestra la imagen justo debajo del menú.
  function initDesignPreview() {
    var tag = document.getElementById('fgp-design-previews');
    if (!tag) return;
    var map;
    try { map = JSON.parse(tag.textContent); } catch (e) { return; }
    if (typeof map === 'string') { try { map = JSON.parse(map); } catch (e) { return; } }
    if (!map) return;
    // Globo: el número va al inicio ("2. Fairy"). Variante: puede venir como "Option 2: With red details".
    function urlFor(val) {
      val = (val || '').trim();
      if (map[val]) return map[val];
      var m = val.match(/^(?:option\s*|design\s*)?(\d+)/i);
      return m && map[m[1]] ? map[m[1]] : null;
    }
    function show(input) {
      var el = input.closest('.gpo-element, .fgp-dvariant');
      if (!el) return;
      var box = el.querySelector('.fgp-dprev');
      var url = urlFor(input.value);
      if (!url) { if (box) box.hidden = true; return; }
      if (!box) {
        box = document.createElement('figure');
        box.className = 'fgp-dprev';
        box.innerHTML = '<img alt=""><figcaption></figcaption>';
        var anchor = el.querySelector('.gpo-dropdown, .select, select') || el.lastElementChild;
        anchor.parentNode.insertBefore(box, anchor.nextSibling);
      }
      var img = box.querySelector('img');
      img.src = url + (url.indexOf('?') < 0 ? '?' : '&') + 'width=900';
      img.alt = input.value;
      var v = input.value.trim();
      // Menú de fuente (ej. "Choose your font": Arial / Monotype) → "Your font:"
      var isFont = /font/i.test(input.name || '') || /font/i.test((el.querySelector('.gpo-label, label, legend') || {}).textContent || '');
      box.querySelector('figcaption').textContent = (isFont ? 'Your font: ' : 'Your design: ') +(/^\d+$/.test(v) ? 'Design ' + v : v.replace(/^(?:option\s*|design\s*)?\d+\s*[.:)\-–]?\s*/i, ''));
      box.hidden = false;
      box.classList.remove('is-in'); void box.offsetWidth; box.classList.add('is-in');
    }
    // El diseño también puede ser una opción de variante de Shopify ("Choose your design: 1…6").
    // Solo se usa en opciones cuyo nombre dice "design", para no confundir tallas tipo "1\" x 3\"".
    function markVariants() {
      document.querySelectorAll('variant-selects .product-form__input, variant-radios fieldset.product-form__input').forEach(function (box) {
        var label = (box.querySelector('label, legend') || {}).textContent || '';
        var sel = box.querySelector('select');
        var name = sel ? sel.name : ((box.querySelector('input') || {}).name || '');
        if (/design|style|template/i.test(label + ' ' + name)) box.classList.add('fgp-dvariant');
      });
    }
    markVariants();
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t.closest && t.closest('.fgp-dvariant')) {
        if (t.tagName === 'SELECT' || (t.type === 'radio' && t.checked)) show(t);
        return;
      }
      if (!t.closest || !t.closest('.gpo-app')) return;
      if (t.tagName === 'SELECT') { show({ value: t.value, closest: t.closest.bind(t) }); return; }
      if (t.type === 'radio' && t.checked) show(t);
    });
    // Con vista previa, el texto de ayuda de Globo tipo "Check Image #4 to see the options" sobra:
    // se esconde solo en el menú que tiene fotos. Globo pinta sus campos tarde, por eso se reintenta.
    function tidy() {
      document.querySelectorAll('.gpo-app .gpo-element').forEach(function (el) {
        var has = Array.prototype.some.call(el.querySelectorAll('input[type=radio], option'), function (i) { return urlFor(i.value); });
        if (has) el.querySelectorAll('.gpo-helptext').forEach(function (h) { h.style.display = 'none'; });
      });
      // Si Globo deja una opción marcada al cargar (volver atrás en el navegador)
      document.querySelectorAll('.gpo-app input[type=radio]:checked').forEach(show);
      // Variante de diseño: ya viene elegida (la primera), así que se muestra de una vez
      markVariants();
      document.querySelectorAll('.fgp-dvariant select, .fgp-dvariant input[type=radio]:checked').forEach(function (i) {
        if (!i.closest('.fgp-dvariant').querySelector('.fgp-dprev')) show(i);
      });
    }
    [800, 2000, 4000].forEach(function (ms) { setTimeout(tidy, ms); });
  }

  // ---------- Orientación del logo (Globo "Logo Orientation": Vertical / Horizontal) ----------
  // Debajo del menú de Globo se pintan dos tarjetas con un rectángulo punteado "YOUR LOGO HERE",
  // uno vertical y otro horizontal, para que se entienda qué significa cada opción. Tocar una
  // tarjeta elige esa opción en Globo (click en su label). No usa imágenes: son SVG en línea.
  // Aplica a cualquier campo de Globo cuyo título diga "orientation" y tenga opciones
  // vertical/horizontal (o portrait/landscape). Globo pinta tarde y puede repintar, por eso
  // se reintenta y se observa el DOM; build() es idempotente.
  function initOrientationPreview() {
    function kindOf(val) {
      if (/vertical|portrait|tall/i.test(val)) return 'v';
      if (/horizontal|landscape|wide/i.test(val)) return 'h';
      return null;
    }
    function svg(kind) {
      var v = kind === 'v';
      var w = v ? 46 : 86, h = v ? 86 : 46, x = (100 - w) / 2, y = (100 - h) / 2;
      // "YOUR LOGO / LIKE THIS" en dos líneas; en el vertical va girado (se lee de abajo
      // hacia arriba), como iría el logo.
      var txt = '<g' + (v ? ' transform="rotate(-90 50 50)"' : '') + ' font-size="8.6" font-weight="700" letter-spacing=".06em" fill="currentColor" text-anchor="middle">' +
        '<text x="50" y="44.5" dominant-baseline="central">YOUR LOGO</text>' +
        '<text x="50" y="56" dominant-baseline="central">LIKE THIS</text></g>';
      return '<svg viewBox="0 0 100 100" aria-hidden="true" focusable="false">' +
        '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="4" fill="#fff" stroke="currentColor" stroke-width="2" stroke-dasharray="5 3"/>' + txt + '</svg>';
    }
    function build(el) {
      if (el.querySelector('.fgp-orient')) return;
      var label = (el.querySelector('.gpo-label') || {}).textContent || '';
      if (!/orientation/i.test(label)) return;
      var radios = Array.prototype.filter.call(el.querySelectorAll('input[type=radio]'), function (r) { return kindOf(r.value); });
      if (radios.length < 2) return;
      var box = document.createElement('div');
      box.className = 'fgp-orient';
      box.setAttribute('role', 'group');
      box.setAttribute('aria-label', label.trim());
      function sync() {
        box.querySelectorAll('.fgp-orient__card').forEach(function (b) { b.setAttribute('aria-pressed', b._fgpRadio.checked ? 'true' : 'false'); });
      }
      radios.forEach(function (r) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'fgp-orient__card fgp-orient__card--' + kindOf(r.value);
        b.innerHTML = svg(kindOf(r.value)) + '<span>' + r.value.trim() + '</span>';
        b._fgpRadio = r;
        b.addEventListener('click', function () {
          var lab = el.querySelector('label[for="' + r.id + '"]');
          if (lab) lab.click(); else r.click();
          if (!r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
          sync();
        });
        box.appendChild(b);
      });
      el.addEventListener('change', sync);
      var anchor = el.querySelector('.gpo-dropdown, .gpo-radio, .gpo-swatch, select') || el.lastElementChild;
      anchor.parentNode.insertBefore(box, anchor.nextSibling);
      // Con las tarjetas, el menú desplegable de Globo sobra: se esconde (los radios siguen
      // en el formulario y el valor viaja igual en properties[Logo Orientation]).
      el.classList.add('fgp-has-orient');
      sync();
    }
    function scan() { document.querySelectorAll('.gpo-app .gpo-element').forEach(build); }
    [600, 1500, 3000, 6000].forEach(function (ms) { setTimeout(scan, ms); });
    if (window.MutationObserver) {
      var t = null;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 150); })
        .observe(document.body, { childList: true, subtree: true });
    }
  }

  // ---------- Pedido para todo el equipo (name tags, 16-oct-2026) ----------
  // Solo si main-product.liquid imprimió <script id="fgp-team"> (los 3 name tags genéricos).
  // Arriba de "Line 1" de Globo sale "Ordering for your team?": se pega la lista (una persona
  // por línea: nombre, cargo) o se sube un Excel/CSV. Con la lista prendida:
  //   - las cajas Line 1–3 de Globo se esconden y se llenan con la primera persona (Globo
  //     exige Line 1; el valor real es la lista),
  //   - la cantidad = número de personas, fija,
  //   - la lista viaja en properties[Team list] como "1. Nombre | Cargo" por línea.
  // El poller (shopify_to_record._fam_team_list) arma un tag por línea.
  // Productos sin Globo (window badge, 19-oct-2026): las "Line N" son campos fg_field; con
  // cfg.single cada línea es UN texto (sin partir por comas) de hasta cfg.max caracteres, y
  // con cfg.style la caja y el campo Line solo salen si la variante tiene ese estilo.
  function initTeam() {
    var cfg = document.getElementById('fgp-team');
    if (!cfg) return;
    try { cfg = JSON.parse(cfg.textContent); } catch (e) { return; }
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    var formId = form.getAttribute('id');
    var variants = null, built = false;
    fetch('/products/' + cfg.handle + '.js').then(function (r) { return r.json(); })
      .then(function (p) { variants = p.variants; refresh(); }).catch(function () {});

    // Recurrentes de dos líneas (20-oct-2026): AAS etiqueta sus campos "Name"/"Title".
    var LABEL_RE = cfg.labels ? new RegExp(cfg.labels, 'i') : /^\s*line\s*\d/i;
    function lineEls() {
      var globo = Array.prototype.filter.call(document.querySelectorAll('.gpo-app .gpo-element'), function (el) {
        return LABEL_RE.test((el.querySelector('.gpo-label') || {}).textContent || '') &&
          !!el.querySelector('input[type=text], textarea');
      });
      if (globo.length) return globo;
      return Array.prototype.filter.call(document.querySelectorAll('.fgp-field'), function (el) {
        return /^\s*line\s*\d/i.test((el.querySelector('.fgp-field__label') || {}).textContent || '');
      });
    }
    // ¿La variante elegida lleva texto? (solo productos con cfg.style)
    function styleOn() {
      if (!cfg.style) return true;
      var id = (form.querySelector('input[name="id"]') || {}).value;
      var v = variants && variants.filter(function (x) { return String(x.id) === String(id); })[0];
      if (v) return v.options.indexOf(cfg.style) >= 0;
      return Array.prototype.some.call(document.querySelectorAll('variant-selects select, variant-radios input:checked'), function (el) { return el.value === cfg.style; });
    }
    function parse(text) {
      var out = [];
      (text || '').split(/\r?\n/).forEach(function (row, i) {
        row = row.trim();
        if (!row) return;
        if (cfg.single) {
          row = row.replace(/\t+/g, ' ').replace(/^"|"$/g, '').trim();
          if (!out.length && /^(full\s*)?(name|text|title|line\s*1)$/i.test(row)) return;
          out.push([row]);
          return;
        }
        var parts = row.indexOf('\t') >= 0 ? row.split('\t')
          : row.indexOf(',') >= 0 ? row.split(',')
          : row.split(/\s+[|;–-]\s+|;/);
        parts = parts.map(function (s) { return s.trim(); }).filter(Boolean);
        if (!parts.length) return;
        // Encabezado de Excel ("Name, Title")
        if (!out.length && /^(full\s*)?name$/i.test(parts[0])) return;
        if (parts.length > 3) parts = [parts[0], parts[1], parts.slice(2).join(', ')];
        out.push(parts);
      });
      return out;
    }
    function money(cents) { return '$' + (cents / 100).toFixed(2); }
    // Precio por volumen (16-oct-2026): 3 descuentos AUTOMÁTICOS en Shopify ("Team pricing: …"),
    // por cantidad total de los 3 name tags. Si se cambian en Shopify, cambiar aquí también.
    // Shopify descuenta por pieza y redondea hacia abajo al centavo (899 × 8% = 71¢).
    var TIERS = [{ min: 25, pct: 12 }, { min: 15, pct: 10 }, { min: 10, pct: 8 }];
    if (cfg.recurrent) TIERS = [];   // las listas de clientes recurrentes no tienen descuento por volumen
    function tierFor(n) { for (var i = 0; i < TIERS.length; i++) if (n >= TIERS[i].min) return TIERS[i]; return null; }
    function nextTier(n) { for (var i = TIERS.length - 1; i >= 0; i--) if (n < TIERS[i].min) return TIERS[i]; return null; }
    function priceCents() {
      var id = (form.querySelector('input[name="id"]') || {}).value;
      var v = variants && variants.filter(function (x) { return String(x.id) === String(id); })[0];
      return v ? v.price : null;
    }

    var box, ta, cb, count, prev, hidden, err;
    function build() {
      var lines = lineEls();
      // cfg.always (PGH): sin campos Line N, la caja va antes de Quantity y siempre abierta.
      var anchor = lines[0] || (cfg.always && document.querySelector('.product-form__quantity'));
      if (built || !anchor) return;
      built = true;
      box = document.createElement('div');
      box.className = 'fgp-team';
      var lbl = cfg.single
        ? 'One badge per line: the text printed next to your logo (up to ' + cfg.max + ' characters). We make one badge for each line.'
        : 'One person per line: name, then title (optional). We make one tag for each line.';
      var ph = cfg.single ? 'General Manager\nSales Associate\nFront Desk' : 'Ana Lopez, Sales Manager\nJohn Smith, Realtor\nMaria Diaz';
      var up = cfg.single ? 'One badge per row: the text in column A' : 'One person per row: name in column A, title in column B';
      box.innerHTML =
        '<label class="fgp-team__toggle"><input type="checkbox">' +
        '<span><strong>Need more than one name tag? Order in bulk</strong><small>' + (cfg.recurrent ? 'Check this box to add your whole list at once: one person per line, name and then title. We make one tag for each line.' : cfg.single ? 'Check this box to order for your whole team: paste a different text for each badge, one per line. Logo, color and backing are chosen once. The more you order, the more you save.' : 'Check this box to order for your whole team: paste all the names at once, one per line. Logo, color and layout are chosen once. The more you order, the more you save.') + '</small></span></label>' +
        (TIERS.length ? '<div class="fgp-team__tiers" aria-label="Team pricing">' +
          TIERS.slice().reverse().map(function (t) { return '<span><b>' + t.min + '+ tags</b>' + t.pct + '% off</span>'; }).join('') +
        '</div>' : '') +
        '<div class="fgp-team__body" hidden>' +
          '<label class="fgp-team__label" for="fgp-team-names">' + lbl + '</label>' +
          '<textarea id="fgp-team-names" rows="6" placeholder="' + ph + '"></textarea>' +
          '<div class="fgp-team__row">' +
            '<label class="fgp-team__upload fgp-back__upload">' +
              '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M12 16V4m0 0-4.5 4.5M12 4l4.5 4.5M5 15v3a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-3" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
              '<span>Upload your list (Excel or CSV)<small>' + up + '</small></span>' +
              '<input type="file" accept=".xlsx,.xls,.csv,.txt"></label>' +
            '<span class="fgp-team__count" aria-live="polite"></span>' +
          '</div>' +
          '<ol class="fgp-team__prev"></ol>' +
          '<p class="fgp-team__err" hidden></p>' +
        '</div>';
      anchor.parentNode.insertBefore(box, anchor);
      cb = box.querySelector('input[type=checkbox]');
      ta = box.querySelector('textarea');
      count = box.querySelector('.fgp-team__count');
      prev = box.querySelector('.fgp-team__prev');
      err = box.querySelector('.fgp-team__err');
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.setAttribute('form', formId);
      form.appendChild(hidden);

      if (cfg.always) {
        cb.checked = true;
        box.querySelector('.fgp-team__toggle').hidden = true;
        box.querySelector('.fgp-team__body').hidden = false;
        box.classList.add('is-on');
      }
      cb.addEventListener('change', function () {
        box.querySelector('.fgp-team__body').hidden = !cb.checked;
        box.classList.toggle('is-on', cb.checked);
        if (cb.checked) ta.focus();
        refresh();
      });
      ta.addEventListener('input', refresh);
      box.querySelector('input[type=file]').addEventListener('change', function (e) {
        var f = e.target.files && e.target.files[0];
        if (f) readFile(f);
      });
    }

    function readFile(f) {
      var put = function (txt) { ta.value = txt.trim(); refresh(); };
      if (/\.(csv|txt)$/i.test(f.name)) {
        var r = new FileReader(); r.onload = function () { put(String(r.result)); }; r.readAsText(f); return;
      }
      var go = function () {
        var r = new FileReader();
        r.onload = function () {
          try {
            var wb = window.XLSX.read(new Uint8Array(r.result), { type: 'array' });
            var rows = window.XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { header: 1, defval: '' });
            put(rows.map(function (row) { return row.map(function (c) { return String(c).trim(); }).filter(Boolean).join('\t'); }).join('\n'));
          } catch (e2) { showErr('We could not read that file. Please paste the names instead.'); }
        };
        r.readAsArrayBuffer(f);
      };
      if (window.XLSX) return go();
      var s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js';
      s.onload = go;
      s.onerror = function () { showErr('We could not read that file. Please paste the names instead.'); };
      document.head.appendChild(s);
    }
    function showErr(msg) { err.textContent = msg; err.hidden = !msg; }

    function setGlobo(el, val) {
      var i = el.querySelector('input[type=text], textarea');
      if (!i || i.value === val) return;
      i.value = val;
      i.dispatchEvent(new Event('input', { bubbles: true }));
      i.dispatchEvent(new Event('change', { bubbles: true }));
    }
    function qtyInputs() { return document.querySelectorAll('input[name="quantity"][form="' + formId + '"], #' + CSS.escape(formId) + ' input[name="quantity"]'); }

    function tooLong(people) {
      if (cfg.max) return people.filter(function (p) { return p.join(' ').length > cfg.max; });
      // Sin cfg.max: cada parte contra el máximo de su campo de Globo (Line 1 de 20, Title de 30…).
      var maxes = lineEls().map(function (el) { var i = el.querySelector('input[type=text], textarea'); return i && i.maxLength > 0 ? i.maxLength : 0; });
      return people.filter(function (p) { return p.some(function (s, i) { return maxes[i] && s.length > maxes[i]; }); });
    }
    function refresh() {
      if (!built) return;
      var show = styleOn();
      box.style.display = show ? '' : 'none';
      if (cfg.style) lineEls().forEach(function (el) {
        el.style.display = show ? '' : 'none';
        var i = el.querySelector('input[type=text], textarea');
        if (!show && i) i.value = '';   // "Logo only": que no viaje un texto escrito antes
      });
      if (!show && cb.checked) { cb.checked = false; box.querySelector('.fgp-team__body').hidden = true; box.classList.remove('is-on'); }
      var on = cb.checked;
      var people = on ? parse(ta.value) : [];
      var lines = lineEls();
      lines.forEach(function (el) { el.classList.toggle('fgp-team-hide', on); });
      if (on) {
        hidden.name = 'properties[Team list]';
        hidden.value = people.map(function (p, i) { return (i + 1) + '. ' + p.join(' | '); }).join('\n');
        var first = people[0] || [];
        lines.forEach(function (el, i) { setGlobo(el, first[i] || ''); });
        qtyInputs().forEach(function (q) { q.value = Math.max(1, people.length); q.readOnly = true; });
        var c = priceCents(), n = people.length, t = tierFor(n), nx = nextTier(n);
        count.innerHTML = '';
        if (n) {
          var line = n + ' name tag' + (n > 1 ? 's' : '');
          if (c && t) {
            var off = Math.floor(c * t.pct / 100);
            line += ' · <s>' + money(c * n) + '</s> ' + money((c - off) * n) + ' <em>' + t.pct + '% off</em>';
          } else if (c) {
            line += ' · ' + money(c * n);
          }
          if (nx) line += '<small>Add ' + (nx.min - n) + ' more for ' + nx.pct + '% off</small>';
          count.innerHTML = line;
        }
        box.querySelectorAll('.fgp-team__tiers span').forEach(function (s, i) {
          s.classList.toggle('is-on', !!t && TIERS.slice().reverse()[i].min === t.min);
        });
        prev.innerHTML = '';
        people.slice(0, 3).forEach(function (p) {
          var li = document.createElement('li'); li.textContent = p.join(' · '); prev.appendChild(li);
        });
        if (people.length > 3) {
          var more = document.createElement('li'); more.className = 'is-more';
          more.textContent = '+ ' + (people.length - 3) + ' more'; prev.appendChild(more);
        }
        var largos = tooLong(people);
        if (largos.length) showErr((cfg.max ? 'Each line can have up to ' + cfg.max + ' characters.' : 'Some names or titles are too long for the tag.') + ' Too long: ' + largos.map(function (p) { return p.join(' '); }).slice(0, 3).join(', '));
        else if (people.length) showErr('');
      } else {
        if (hidden.name) lines.forEach(function (el) { setGlobo(el, ''); });
        hidden.removeAttribute('name');
        hidden.value = '';
        qtyInputs().forEach(function (q) { if (q.readOnly) { q.readOnly = false; q.value = 1; } });
        count.textContent = ''; prev.innerHTML = ''; showErr('');
        box.querySelectorAll('.fgp-team__tiers span').forEach(function (s) { s.classList.remove('is-on'); });
      }
    }

    // Sin nombres no se deja agregar al carrito (captura: corre antes que Globo y el theme).
    document.addEventListener('click', function (e) {
      if (!built || !cb.checked) return;
      var b = e.target.closest && e.target.closest('button[type=submit], .sticky-product-form__submit');
      if (!b || (b.form !== form && !b.classList.contains('sticky-product-form__submit'))) return;
      refresh();
      if (!parse(ta.value).length || tooLong(parse(ta.value)).length) {
        e.preventDefault(); e.stopImmediatePropagation();
        if (!parse(ta.value).length) showErr(cfg.single ? 'Add at least one line to the list.' : 'Add at least one name to the team list.');
        box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, true);
    // Los botones +/- del theme cambian la cantidad: con la lista prendida se vuelve a fijar.
    document.addEventListener('change', function (e) {
      if (built && cb.checked && e.target.name === 'quantity') refresh();
      if (built && e.target.closest && e.target.closest('variant-selects, variant-radios')) setTimeout(refresh, 300);
    });
    document.addEventListener('click', function (e) {
      if (built && cb.checked && e.target.closest && e.target.closest('.quantity__button')) setTimeout(refresh, 0);
    });

    // Recurrentes (20-oct-2026, María): el campo de archivo de Globo ("File Upload", "Upload your
    // Names & Titles file") sobra al lado del botón de Excel/CSV de la lista → se esconde y se vacía.
    function hideGloboFiles() {
      if (!cfg.recurrent) return;
      document.querySelectorAll('.gpo-app .gpo-element').forEach(function (el) {
        var f = el.querySelector('input[type=file]');
        if (!f || el.classList.contains('fgp-team-hide-file')) return;
        el.classList.add('fgp-team-hide-file');
        f.required = false; f.removeAttribute('required');
        el.querySelectorAll('.gpo-label').forEach(function (l) { l.classList.remove('required'); });
      });
    }
    function scan() { hideGloboFiles(); build(); if (built) refresh(); }
    [600, 1500, 3000, 6000].forEach(function (ms) { setTimeout(scan, ms); });
    if (window.MutationObserver) {
      var t = null;
      new MutationObserver(function () { hideGloboFiles(); if (built && box.isConnected) return; built = built && box.isConnected; clearTimeout(t); t = setTimeout(scan, 150); })
        .observe(document.body, { childList: true, subtree: true });
    }
  }


  // ---------- Lista de nombres EMAUS (20-oct-2026) ----------
  // Solo si main-product.liquid imprimió <script id="fgp-names">. Un nombre por línea,
  // pegado o desde Excel/CSV (columna A); la cantidad se pone sola = nº de nombres.
  //   - cfg.globo: texto de la etiqueta de Globo donde van los nombres (hombres).
  //   - cfg.prop: sin Globo, caja propia que viaja en properties[cfg.prop] (mujeres).
  function initNames() {
    var cfg = document.getElementById('fgp-names');
    if (!cfg) return;
    try { cfg = JSON.parse(cfg.textContent); } catch (e) { return; }
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    var formId = form.getAttribute('id');
    var box, ta, count, err, lastN = 0;

    function globoEl() {
      return Array.prototype.filter.call(document.querySelectorAll('.gpo-app .gpo-element'), function (el) {
        return ((el.querySelector('.gpo-label') || {}).textContent || '').toLowerCase().indexOf(cfg.globo) >= 0;
      })[0];
    }
    function names() {
      return (ta && ta.value || '').split(/\r?\n|,|;/).map(function (s) {
        return s.replace(/\t+/g, ' ').replace(/^"|"$/g, '').trim();
      }).filter(Boolean);
    }
    function qtyInputs() { return document.querySelectorAll('input[name="quantity"][form="' + formId + '"], #' + CSS.escape(formId) + ' input[name="quantity"]'); }
    function refresh() {
      if (!box) return;
      var n = names().length;
      count.textContent = n ? n + ' name' + (n > 1 ? 's' : '') + ' · ' + n + ' tag' + (n > 1 ? 's' : '') : '';
      if (n && n !== lastN) qtyInputs().forEach(function (q) { q.value = n; q.dispatchEvent(new Event('change', { bubbles: true })); });
      lastN = n;
    }
    function put(txt) {
      ta.value = txt.trim();
      ta.dispatchEvent(new Event('input', { bubbles: true }));
      ta.dispatchEvent(new Event('change', { bubbles: true }));
      refresh();
    }
    function showErr(msg) { err.textContent = msg; err.hidden = !msg; }
    // Excel/CSV: el nombre es la 1ª celda con texto de cada fila; se salta el encabezado.
    function fromRows(rows) {
      var out = [];
      rows.forEach(function (row) {
        var c = row.map(function (x) { return String(x).trim(); }).filter(Boolean)[0];
        if (!c || (!out.length && /^(full\s*)?names?$/i.test(c))) return;
        out.push(c);
      });
      return out.join('\n');
    }
    function readFile(f) {
      showErr('');
      if (/\.(csv|txt)$/i.test(f.name)) {
        var r = new FileReader();
        r.onload = function () { put(fromRows(String(r.result).split(/\r?\n/).map(function (l) { return l.split(/[,;\t]/); }))); };
        r.readAsText(f); return;
      }
      var go = function () {
        var r = new FileReader();
        r.onload = function () {
          try {
            var wb = window.XLSX.read(new Uint8Array(r.result), { type: 'array' });
            put(fromRows(window.XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { header: 1, defval: '' })));
          } catch (e2) { showErr('We could not read that file. Please paste the names instead.'); }
        };
        r.readAsArrayBuffer(f);
      };
      if (window.XLSX) return go();
      var s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js';
      s.onload = go;
      s.onerror = function () { showErr('We could not read that file. Please paste the names instead.'); };
      document.head.appendChild(s);
    }

    function build() {
      if (box && box.isConnected) return;
      var anchor, own = !cfg.globo;
      if (own) anchor = document.querySelector('.product-form__quantity');
      else { anchor = globoEl(); ta = anchor && anchor.querySelector('textarea, input[type=text]'); }
      if (!anchor || (!own && !ta)) return;
      box = document.createElement('div');
      box.className = 'fgp-team fgp-names is-on';
      box.innerHTML =
        (own ? '<label class="fgp-team__label" for="fgp-names-list">Names to engrave<small> One name per line. We make one tag for each name.</small></label>' +
               '<textarea id="fgp-names-list" rows="6" name="properties[' + cfg.prop + ']" form="' + formId + '" placeholder="Maria Lopez\nAna Diaz\nCarmen Ruiz"></textarea>' : '') +
        '<div class="fgp-team__row">' +
          '<label class="fgp-team__upload fgp-back__upload">' +
            '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M12 16V4m0 0-4.5 4.5M12 4l4.5 4.5M5 15v3a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-3" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            '<span>' + (own ? 'Or upload' : 'Upload') + ' your list (Excel or CSV)<small>One name per row, in column A</small></span>' +
            '<input type="file" accept=".xlsx,.xls,.csv,.txt"></label>' +
          '<span class="fgp-team__count" aria-live="polite"></span>' +
        '</div>' +
        '<p class="fgp-team__err" hidden></p>';
      if (own) anchor.parentNode.insertBefore(box, anchor);
      else anchor.appendChild(box);
      if (own) ta = box.querySelector('textarea');
      count = box.querySelector('.fgp-team__count');
      err = box.querySelector('.fgp-team__err');
      ta.addEventListener('input', refresh);
      box.querySelector('input[type=file]').addEventListener('change', function (e) {
        var f = e.target.files && e.target.files[0];
        if (f) readFile(f);
        e.target.value = '';
      });
      refresh();
    }
    [600, 1500, 3000, 6000].forEach(function (ms) { setTimeout(build, ms); });
    if (window.MutationObserver) {
      var t = null;
      new MutationObserver(function () { if (box && box.isConnected) return; clearTimeout(t); t = setTimeout(build, 150); })
        .observe(document.body, { childList: true, subtree: true });
    }
  }

  // ---------- Personalización atrás de los vasos (17-oct-2026) ----------
  // Solo si main-product.liquid imprimió <script id="fgp-back"> (vasos de logo de la lista
  // fg_back_ids). Abajo de los campos de Globo sale "Back customization" (+$2.50 por vaso):
  //   - "Same text on every cup": 2 líneas de 20 caracteres → properties[Back text].
  //   - "Another logo": archivo → properties[Back logo] (Shopify lo sube a su CDN).
  //   - "A different text on each cup": una línea por vaso ("Línea 1, Línea 2"), pegada
  //     o desde Excel/CSV → properties[Back text list] "1. Línea 1 / Línea 2".
  // Vasos con texto atrás: _back_cups (por unidad de la línea: vasos del paquete de la
  // variante, "12 / Black" = 12) o _back_total (lista: un vaso por nombre, fijo).
  // El cobro lo pone snippets/fg-back-guard.liquid: una línea "Back customization"
  // ($2.50, variante en cfg.variant) con cantidad = suma de esos vasos.
  function initBack() {
    var cfg = document.getElementById('fgp-back');
    if (!cfg) return;
    try { cfg = JSON.parse(cfg.textContent); } catch (e) { return; }
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    var formId = form.getAttribute('id');
    var MAX = 20, PRICE = cfg.price || 250;
    var product = null, built = false;
    // Si la página abre en la muestra en blanco (sin ?variant=), pasar a la primera cantidad
    // real para que la opción de atrás se vea de entrada (María, 31-oct-2026).
    function skipBlank() {
      if (/[?&]variant=/.test(location.search)) return;
      var sel = [].filter.call(document.querySelectorAll('variant-selects select'), function (s) {
        return s.selectedOptions[0] && /blank/i.test(s.value);
      })[0];
      if (!sel) return;
      var opt = [].filter.call(sel.options, function (o) { return !/blank/i.test(o.value); })[0];
      if (!opt) return;
      sel.value = opt.value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
    fetch('/products/' + cfg.handle + '.js').then(function (r) { return r.json(); })
      .then(function (p) { product = p; skipBlank(); refresh(); }).catch(function () {});

    function money(c) { return '$' + (c / 100).toFixed(2); }
    function variant() {
      var id = (form.querySelector('input[name="id"]') || {}).value;
      return product && product.variants.filter(function (x) { return String(x.id) === String(id); })[0];
    }
    // Vasos por unidad: el número con que empieza la opción "How many…" de la variante.
    function perUnit() {
      var v = variant();
      if (!v) return 1;
      var n = 1;
      product.options.forEach(function (o, i) {
        var name = typeof o === 'string' ? o : o.name;
        var val = v.options[i] || '';
        if (/how\s*many|quantity|pack/i.test(name)) { var m = /^\s*(\d+)/.exec(val); if (m) n = +m[1]; }
      });
      return n;
    }
    function isBlank() { var v = variant(); return !!(v && /blank/i.test(v.title)); }
    function qty() { var q = document.querySelector('input[name="quantity"][form="' + formId + '"]') || form.querySelector('input[name="quantity"]'); return Math.max(1, parseInt(q && q.value, 10) || 1); }
    function cups() { return perUnit() * qty(); }

    function parse(text) {
      var out = [];
      (text || '').split(/\r?\n/).forEach(function (row) {
        row = row.trim();
        if (!row) return;
        var parts = row.indexOf('\t') >= 0 ? row.split('\t') : row.indexOf(',') >= 0 ? row.split(',') : row.split(/\s+[|\/;–-]\s+|;|\|/);
        parts = parts.map(function (s) { return s.trim(); }).filter(Boolean);
        if (!parts.length) return;
        if (!out.length && /^(line\s*1|name|text|front|back)$/i.test(parts[0])) return; // encabezado
        if (parts.length > 2) parts = [parts[0], parts.slice(1).join(' ')];
        out.push(parts);
      });
      return out;
    }

    var box, cb, mode, l1, l2, ta, info, err, prev, hText, hList, hCups, hTotal, logoIn;
    function hidden(name) {
      var i = document.createElement('input'); i.type = 'hidden'; i.setAttribute('form', formId); i.dataset.name = name; form.appendChild(i); return i;
    }
    function build() {
      var anchor = document.querySelector('.gpo-container') || form.querySelector('.product-form__buttons');
      if (built || !anchor || !document.querySelector('.gpo-app .gpo-element')) return;
      built = true;
      box = document.createElement('div');
      box.className = 'fgp-team fgp-back';
      box.innerHTML =
        '<label class="fgp-team__toggle"><input type="checkbox">' +
        '<span><strong>Add personalization on the back <em>+' + money(PRICE) + ' per cup</em></strong>' +
        '<small>Want another logo or text on the back too?</small></span></label>' +
        '<div class="fgp-team__body" hidden>' +
          '<div class="fgp-back__modes" role="radiogroup">' +
            '<label><input type="radio" name="fgp-back-mode" value="same" checked><span>Same text on every cup</span></label>' +
            '<label><input type="radio" name="fgp-back-mode" value="list"><span>A different text on each cup</span></label>' +
            '<label><input type="radio" name="fgp-back-mode" value="logo"><span>Another logo</span></label>' +
          '</div>' +
          '<div class="fgp-back__same">' +
            '<label class="fgp-team__label" for="fgp-back-l1">Line 1</label>' +
            '<input type="text" id="fgp-back-l1" maxlength="' + MAX + '" placeholder="e.g. The Smith Team" autocomplete="off">' +
            '<label class="fgp-team__label" for="fgp-back-l2">Line 2 <small>(optional)</small></label>' +
            '<input type="text" id="fgp-back-l2" maxlength="' + MAX + '" placeholder="e.g. smithrealty.com" autocomplete="off">' +
            '<p class="fgp-back__hint">Up to 2 lines of ' + MAX + ' characters each.</p>' +
          '</div>' +
          '<div class="fgp-back__list" hidden>' +
            '<label class="fgp-team__label" for="fgp-back-names">One cup per line. For a second line, add a comma: Line 1, Line 2</label>' +
            '<textarea id="fgp-back-names" rows="6" placeholder="Ana Lopez, Sales Manager\nJohn Smith\nThe Diaz Family, Est. 2026"></textarea>' +
            '<div class="fgp-team__row"><label class="fgp-team__upload fgp-back__upload">' +
              '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M12 16V4m0 0-4.5 4.5M12 4l4.5 4.5M5 15v3a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-3" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
              '<span>Upload your list (Excel or CSV)<small>One cup per row: Line 1 in column A, Line 2 in column B</small></span>' +
              '<input type="file" class="fgp-back__listfile" accept=".xlsx,.xls,.csv,.txt"></label></div>' +
            '<ol class="fgp-team__prev"></ol>' +
          '</div>' +
          '<div class="fgp-back__logo" hidden>' +
            '<label class="fgp-team__upload fgp-back__upload">' +
              '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M12 16V4m0 0-4.5 4.5M12 4l4.5 4.5M5 15v3a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-3" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
              '<span class="fgp-back__logo-name">Upload the logo for the back<small>PNG, JPG, PDF, AI or SVG. Same logo on every cup.</small></span>' +
              '<input type="file" id="fgp-back-logo" accept=".png,.jpg,.jpeg,.pdf,.ai,.eps,.svg,.webp,.heic,image/*,application/pdf"></label>' +
          '</div>' +
          '<p class="fgp-team__count" aria-live="polite"></p>' +
          '<p class="fgp-team__err" hidden></p>' +
        '</div>';
      if (anchor.classList.contains('gpo-container')) anchor.appendChild(box); else anchor.parentNode.insertBefore(box, anchor);
      cb = box.querySelector('input[type=checkbox]');
      l1 = box.querySelector('#fgp-back-l1'); l2 = box.querySelector('#fgp-back-l2');
      ta = box.querySelector('textarea');
      info = box.querySelector('.fgp-team__count'); err = box.querySelector('.fgp-team__err'); prev = box.querySelector('.fgp-team__prev');
      hText = hidden('properties[Back text]'); hList = hidden('properties[Back text list]');
      hCups = hidden('properties[_back_cups]'); hTotal = hidden('properties[_back_total]');
      logoIn = box.querySelector('#fgp-back-logo');
      logoIn.setAttribute('form', formId); logoIn.dataset.name = 'properties[Back logo]';
      logoIn.addEventListener('change', function () {
        var f = logoIn.files && logoIn.files[0];
        box.querySelector('.fgp-back__logo-name').innerHTML = f
          ? 'Back logo: ' + f.name.replace(/[<>&]/g, '') + '<small>Tap to change it</small>'
          : 'Upload the logo for the back<small>PNG, JPG, PDF, AI or SVG. Same logo on every cup.</small>';
        refresh();
      });
      cb.addEventListener('change', function () {
        box.querySelector('.fgp-team__body').hidden = !cb.checked;
        box.classList.toggle('is-on', cb.checked);
        if (cb.checked) (mode() === 'list' ? ta : l1).focus();
        refresh();
      });
      box.querySelectorAll('input[name=fgp-back-mode]').forEach(function (r) {
        r.addEventListener('change', function () {
          box.querySelector('.fgp-back__same').hidden = mode() !== 'same';
          box.querySelector('.fgp-back__list').hidden = mode() !== 'list';
          box.querySelector('.fgp-back__logo').hidden = mode() !== 'logo';
          refresh();
        });
      });
      [l1, l2, ta].forEach(function (i) { i.addEventListener('input', refresh); });
      box.querySelector('.fgp-back__listfile').addEventListener('change', function (e) {
        var f = e.target.files && e.target.files[0];
        if (f) readFile(f);
      });
    }
    function mode() { var r = box.querySelector('input[name=fgp-back-mode]:checked'); return r ? r.value : 'same'; }

    function readFile(f) {
      var put = function (txt) { ta.value = txt.trim(); refresh(); };
      var fail = function () { showErr('We could not read that file. Please paste the text instead.'); };
      if (/\.(csv|txt)$/i.test(f.name)) { var r = new FileReader(); r.onload = function () { put(String(r.result)); }; r.readAsText(f); return; }
      var go = function () {
        var r = new FileReader();
        r.onload = function () {
          try {
            var wb = window.XLSX.read(new Uint8Array(r.result), { type: 'array' });
            var rows = window.XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { header: 1, defval: '' });
            put(rows.map(function (row) { return row.map(function (c) { return String(c).trim(); }).filter(Boolean).join('\t'); }).join('\n'));
          } catch (e2) { fail(); }
        };
        r.readAsArrayBuffer(f);
      };
      if (window.XLSX) return go();
      var s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js';
      s.onload = go; s.onerror = fail;
      document.head.appendChild(s);
    }
    function showErr(msg) { err.textContent = msg || ''; err.hidden = !msg; }
    function setH(i, val) { if (val) { i.name = i.dataset.name; i.value = val; } else { i.removeAttribute('name'); i.value = ''; } }

    // Devuelve el error que impide agregar al carrito ('' si todo bien).
    function problem() {
      if (!cb.checked) return '';
      if (mode() === 'same') return l1.value.trim() || l2.value.trim() ? '' : 'Write the text for the back, or uncheck the box.';
      if (mode() === 'logo') return logoIn.files && logoIn.files.length ? '' : 'Upload the logo for the back, or uncheck the box.';
      var people = parse(ta.value), n = cups();
      if (!people.length) return 'Add the text for at least one cup, or uncheck the box.';
      if (people.length > n) return 'You have ' + people.length + ' lines but ' + n + ' cup' + (n > 1 ? 's' : '') + '. Choose more cups or remove ' + (people.length - n) + ' line' + (people.length - n > 1 ? 's' : '') + '.';
      var long = people.filter(function (p) { return p.some(function (x) { return x.length > MAX; }); });
      if (long.length) return 'Each line can have up to ' + MAX + ' characters. Please shorten: ' + long.slice(0, 3).map(function (p) { return '“' + p.join(', ') + '”'; }).join(' ');
      return '';
    }

    function refresh() {
      if (!built) return;
      var blank = isBlank();
      box.hidden = blank;
      var on = cb.checked && !blank;
      setH(hText, ''); setH(hList, ''); setH(hCups, ''); setH(hTotal, '');
      logoIn.removeAttribute('name');
      info.innerHTML = ''; prev.innerHTML = '';
      if (!on) { showErr(''); return; }
      var n = cups(), lines;
      if (mode() === 'same') {
        lines = [l1.value.trim(), l2.value.trim()].filter(Boolean);
        if (lines.length) {
          setH(hText, lines.join(' / '));
          setH(hCups, String(perUnit()));
          info.innerHTML = n + ' cup' + (n > 1 ? 's' : '') + ' with text on the back · +' + money(PRICE * n);
        }
      } else if (mode() === 'logo') {
        if (logoIn.files && logoIn.files.length) {
          logoIn.name = logoIn.dataset.name;
          setH(hCups, String(perUnit()));
          info.innerHTML = n + ' cup' + (n > 1 ? 's' : '') + ' with a logo on the back · +' + money(PRICE * n);
        }
      } else {
        var people = parse(ta.value);
        if (people.length) {
          setH(hList, people.map(function (p, i) { return (i + 1) + '. ' + p.join(' / '); }).join('\n'));
          setH(hTotal, String(Math.min(people.length, n)));
          info.innerHTML = people.length + ' of ' + n + ' cup' + (n > 1 ? 's' : '') + ' with text on the back · +' + money(PRICE * Math.min(people.length, n)) +
            (people.length < n ? '<small>The other ' + (n - people.length) + ' will have nothing on the back.</small>' : '');
          people.slice(0, 3).forEach(function (p) { var li = document.createElement('li'); li.textContent = p.join(' · '); prev.appendChild(li); });
          if (people.length > 3) { var more = document.createElement('li'); more.className = 'is-more'; more.textContent = '+ ' + (people.length - 3) + ' more'; prev.appendChild(more); }
        }
      }
      var pb = problem();
      if (!pb || err.textContent) showErr(pb && err.textContent ? pb : '');
    }

    // Sin texto (o con la lista mal) no se deja agregar al carrito.
    document.addEventListener('click', function (e) {
      if (!built || !cb.checked || box.hidden) return;
      var b = e.target.closest && e.target.closest('button[type=submit], .sticky-product-form__submit');
      if (!b || (b.form !== form && !b.classList.contains('sticky-product-form__submit'))) return;
      refresh();
      var pb = problem();
      if (pb) {
        e.preventDefault(); e.stopImmediatePropagation();
        showErr(pb);
        box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, true);
    document.addEventListener('change', function (e) {
      if (!built) return;
      if (e.target.name === 'quantity') refresh();
      if (e.target.closest && e.target.closest('variant-selects, variant-radios')) setTimeout(refresh, 300);
    });
    document.addEventListener('click', function (e) {
      if (built && e.target.closest && e.target.closest('.quantity__button')) setTimeout(refresh, 0);
    });

    function scan() { build(); if (built) refresh(); }
    [600, 1500, 3000, 6000].forEach(function (ms) { setTimeout(scan, ms); });
    if (window.MutationObserver) {
      var t = null;
      new MutationObserver(function () { if (built && box.isConnected) return; built = false; clearTimeout(t); t = setTimeout(scan, 150); })
        .observe(document.body, { childList: true, subtree: true });
    }
  }

  // ---------- Casilla de la prueba digital (20-oct-2026) ----------
  // Solo si main-product.liquid imprimió <script id="fgp-dproof"> (lista fg_proof_ids; por ahora
  // el 20oz grabado). Antes del botón de agregar al carrito: el cliente confirma que va a estar
  // pendiente del correo 24 h para aprobar la prueba digital, y que si no responde la orden se
  // hace tal como la pidió. Sin marcarla no se deja agregar. Marcada → properties[Digital proof]
  // (el agente la lee en Comentarios y manda la prueba: vaso_prueba_digital.py en el servidor).
  function initProof() {
    var cfg = document.getElementById('fgp-dproof');
    if (!cfg) return;
    try { cfg = JSON.parse(cfg.textContent); } catch (e) { return; }
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    var formId = form.getAttribute('id');
    var VALUE = 'Agreed: I will check my email for 24 hours to approve the proof; if I do not reply, the order is made as placed';
    var product = null, box, cb, err, hid;
    fetch('/products/' + cfg.handle + '.js').then(function (r) { return r.json(); })
      .then(function (p) { product = p; refresh(); }).catch(function () {});
    function isBlank() {
      var id = (form.querySelector('input[name="id"]') || {}).value;
      var v = product && product.variants.filter(function (x) { return String(x.id) === String(id); })[0];
      return !!(v && /blank/i.test(v.title));
    }
    // Justo encima del botón (abajo de los campos de Globo y de "Back customization"). Globo
    // mete su caja antes del botón cuando termina de cargar: por eso se vuelve a acomodar.
    function anchor() { return form.querySelector('.product-form__submit') || form.querySelector('.product-form__buttons'); }
    function place() {
      var a = anchor();
      if (box && a && box.nextElementSibling !== a) a.parentNode.insertBefore(box, a);
    }
    function build() {
      if (box) { if (!box.isConnected) box = null; else return place(); }
      var a = anchor();
      if (!a) return;
      box = document.createElement('div');
      box.className = 'fgp-team fgp-dproof';
      box.innerHTML =
        '<label class="fgp-team__toggle"><input type="checkbox">' +
        '<span><strong>I’ll watch my email for the next 24 hours</strong>' +
        '<small>We’ll email you a digital proof of your cups to approve before we make them. ' +
        'If we don’t hear back within 24 hours, your order will be made exactly as you placed it.</small></span></label>' +
        '<p class="fgp-team__err" hidden>Please check the box to confirm you’ll look out for your digital proof.</p>';
      a.parentNode.insertBefore(box, a);
      cb = box.querySelector('input[type=checkbox]');
      err = box.querySelector('.fgp-team__err');
      hid = document.createElement('input'); hid.type = 'hidden'; hid.setAttribute('form', formId); form.appendChild(hid);
      cb.addEventListener('change', function () { if (cb.checked) err.hidden = true; refresh(); });
      refresh();
    }
    function refresh() {
      if (!box) return;
      var blank = isBlank();
      box.hidden = blank;
      box.classList.toggle('is-on', cb.checked);
      if (cb.checked && !blank) { hid.name = 'properties[Digital proof]'; hid.value = VALUE; }
      else { hid.removeAttribute('name'); hid.value = ''; }
    }
    document.addEventListener('click', function (e) {
      if (!box || box.hidden || cb.checked) return;
      var b = e.target.closest && e.target.closest('button[type=submit], .sticky-product-form__submit');
      if (!b || (b.form !== form && !b.classList.contains('sticky-product-form__submit'))) return;
      e.preventDefault(); e.stopImmediatePropagation();
      err.hidden = false;
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, true);
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-selects, variant-radios')) setTimeout(refresh, 300);
    });
    // Globo valida su formulario en un clic de captura propio y corta el evento, así que el
    // clic de arriba no siempre llega. Red de seguridad: si la casilla no está marcada, el
    // pedido a /cart/add de ESTE vaso no sale (el tema muestra el mensaje de error).
    function blocks() { return box && box.isConnected && !box.hidden && !cb.checked; }
    function isThisCup(body) {
      var vid = String((form.querySelector('input[name="id"]') || {}).value || '');
      if (!vid || !body) return false;
      if (typeof FormData !== 'undefined' && body instanceof FormData) return String(body.get('id') || '') === vid;
      return String(body).indexOf(vid) >= 0;
    }
    if (window.fetch && !window.__fgpProofFetch) {
      window.__fgpProofFetch = true;
      var origFetch = window.fetch;
      window.fetch = function (input, init) {
        try {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          if (/\/cart\/add/.test(url) && blocks() && isThisCup(init && init.body)) {
            err.hidden = false;
            box.scrollIntoView({ behavior: 'smooth', block: 'center' });
            var msg = 'Please check the box to confirm you\u2019ll look out for your digital proof.';
            return Promise.resolve(new Response(JSON.stringify({ status: 422, message: msg, description: msg }),
              { status: 422, headers: { 'Content-Type': 'application/json' } }));
          }
        } catch (e2) {}
        return origFetch.apply(this, arguments);
      };
    }
    form.addEventListener('submit', function (e) {
      if (blocks()) { e.preventDefault(); e.stopImmediatePropagation(); err.hidden = false; box.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    }, true);
    build();
    [600, 1500, 3000, 6000, 10000].forEach(function (ms) { setTimeout(build, ms); });
    if (window.MutationObserver) {
      var t = null;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(build, 150); })
        .observe(form, { childList: true, subtree: true });
    }
  }

  // ---------- Vista previa en vivo de los name tags (23-oct-2026) ----------
  // Como en MiaMia: mientras la clienta escribe, se dibuja la placa (SVG) con el color y el
  // tamaño de la variante, el layout de Globo (1–7: Arial/Monotype, sin logo / logo a la
  // izquierda / logo arriba / diseño propio), las líneas y el logo que subió (se lee del
  // archivo local, no espera a que suba). Solo si main-product.liquid imprimió
  // <script id="fgp-nametag"> con {"handle", "shape": rect|oval|window, "finish": printed|engraved}.
  // Window badge (sin Globo): logo arriba (solo, o logo | Line 1 con "Logo + text") y la
  // ventana con el inserto del nombre. No cambia nada de lo que viaja en la orden.
  function initNameTagPreview() {
    var cfg = document.getElementById('fgp-nametag');
    if (!cfg) return;
    try { cfg = JSON.parse(cfg.textContent); } catch (e) { return; }
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    var NS = 'http://www.w3.org/2000/svg';
    var variants = null, box = null, stage = null, logoURL = null, t = null;
    // Archivo local de cada campo: 'logo' (layouts 2/3/5/6 y window) y 'design' (layout 7)
    // [2] = recuadro de la tinta (setLogo lo mide), para dibujar el logo sin su margen
    var files = { logo: [null, null, null], design: [null, null, null] };
    // Office sign: ranura del taller y márgenes (mm), los mismos de etsy/office_sign.py
    var PLATE_MM = { 8: [200.1, 50.8], 10: [251.3, 50.8] }, PL_MX = 9.0, PL_MY = 6.5;
    // Name tag grabado con la página nueva (27-oct-2026): MISMA geometría que
    // amazon/name_tag_logo_v2.py (GEOM): caja de tinta bw × bh (mm) en el tag de 76,2 mm,
    // logo a la izquierda (alto de la caja, ancho máx. w × bw) o arriba (1.5": zona de h × bh).
    var NT_GEOM = { 1: { bw: 68, bh: 21, left: { w: 0.30, gap: 3 } },
                    15: { bw: 68, bh: 32, left: { w: 0.36, gap: 3 }, top: { h: 0.42, w: 0.90, gap: 2.5 } } };
    function ntV2() { return cfg.shape !== 'plate' && !!document.querySelector('.fgnt select[name="properties[Design Option]"]'); }
    // Logo del office sign: tamaño (0,5–1 de lo máximo) y posición en su zona (0–1; 0 = izq./arriba)
    var lzoom = 1, lpos = null, lkey = '', ldrag = null, ctl = null, hSize = null, hPos = null;
    fetch('/products/' + cfg.handle + '.js').then(function (r) { return r.json(); })
      .then(function (p) { variants = p; render(); }).catch(function () {});

    var METAL = {
      silver: ['#f1f2f4', '#b7bcc3', '#8d939b'],
      gold: ['#f6e39a', '#c9a54e', '#a8862f'],
      white: ['#ffffff', '#eceae6', '#c9c5bd'],
      black: ['#3a3a3c', '#151516', '#000000']
    };
    var FONTS = {
      arial: 'Arial, Helvetica, sans-serif',
      monotype: '"Monotype Corsiva", "Apple Chancery", "URW Chancery L", cursive'
    };

    // Opción de la variante elegida cuyo nombre casa con re ("Primary color", "Size & Backing Type"…)
    function opt(re) {
      var id = (form.querySelector('input[name="id"]') || {}).value;
      if (variants) {
        var v = variants.variants.filter(function (x) { return String(x.id) === String(id); })[0];
        if (v) for (var i = 0; i < variants.options.length; i++) if (re.test(variants.options[i].name || variants.options[i])) return v.options[i] || '';
      }
      return '';
    }
    function globoEl(re) {
      return Array.prototype.filter.call(document.querySelectorAll('.gpo-app .gpo-element'), function (el) {
        return re.test((el.querySelector('.gpo-label') || {}).textContent || '');
      })[0];
    }
    function fieldEl(re) {
      return Array.prototype.filter.call(document.querySelectorAll('.fgp-field'), function (el) {
        return re.test((el.querySelector('.fgp-field__label') || {}).textContent || '');
      })[0];
    }
    function lineVal(n) {
      var el = globoEl(new RegExp('^\\s*line\\s*' + n + '\\b', 'i')) || fieldEl(new RegExp('^\\s*line\\s*' + n + '\\b', 'i'));
      var i = el && el.querySelector('input[type=text], textarea');
      return i ? i.value.trim() : '';
    }
    function plateSame() {
      return /same/i.test((document.querySelector('.fgnt select[name="properties[Text style]"]') || {}).value || '');
    }
    function plateBold() {
      return /bold/i.test((document.querySelector('.fgnt select[name="properties[Text style]"]') || {}).value || '');
    }
    function layout() {
      if (cfg.shape === 'plate' || ntV2()) {
        // Office sign: "Design Option" (Only text | Text+Logo | Upload your design) + fuente →
        // los mismos números de los name tags (1/4 texto, 2/5 logo a la izquierda, 7 diseño propio)
        var d = ((document.querySelector('.fgnt select[name="properties[Design Option]"]') || {}).value || '').toLowerCase();
        var mono = /monotype/i.test((document.querySelector('.fgnt select[name="properties[Choose your font]"]') || {}).value || '');
        if (/upload/.test(d)) return 7;
        // Name tag 1.5": "Logo placement" → logo arriba (3 / 6)
        var pl = cfg.shape !== 'plate' && document.querySelector('.fgnt select[name="properties[Logo placement]"]');
        var top = pl && !pl.disabled && /top/i.test(pl.value);
        return (/logo/.test(d) ? (top ? 3 : 2) : 1) + (mono ? 3 : 0);
      }
      var r = document.querySelector('.gpo-app input[type=radio][name="Layout option"]:checked, .fgnt select[name="properties[Layout option]"]');
      var m = r && r.value.match(/^\s*(\d)/);
      return m ? +m[1] : 1;
    }

    function el(name, attrs, text) {
      var n = document.createElementNS(NS, name);
      for (var k in attrs) n.setAttribute(k, attrs[k]);
      if (text != null) n.textContent = text;
      return n;
    }
    // Encoge el texto hasta que quepa en maxW (se mide ya pintado)
    function fit(txt, maxW) {
      try {
        var w = txt.getComputedTextLength();
        if (w > maxW) txt.setAttribute('font-size', (parseFloat(txt.getAttribute('font-size')) * maxW / w).toFixed(1));
      } catch (e) {}
    }
    function logoNode(x, y, w, h, ink, crop) {
      // crop = recuadro de la tinta en la imagen (sin el blanco/transparente de alrededor)
      if (logoURL && crop) {
        // <g> + clipPath, no un <svg> anidado: el CSS del tema pone width:100% a todo svg
        // dentro de la vista previa y lo descuadraba.
        var s = Math.min(w / crop.w, h / crop.h);
        var ox = x + (w - crop.w * s) / 2 - crop.x * s, oy = y + (h - crop.h * s) / 2 - crop.y * s;
        var cid = 'fgpntl' + Math.random().toString(36).slice(2, 7);
        var cp = el('clipPath', { id: cid });
        cp.appendChild(el('rect', { x: x, y: y, width: w, height: h }));
        // clip en la imagen y no en el <g>: un <g> recortado se aísla y el multiply deja de verse
        var gg = el('g', {});
        gg.appendChild(cp);
        gg.appendChild(el('rect', { x: x, y: y, width: w, height: h, fill: 'transparent' }));  // para agarrarlo al arrastrar
        var im = el('image', { href: logoURL, x: ox, y: oy, width: crop.iw * s, height: crop.ih * s, 'clip-path': 'url(#' + cid + ')' });
        // El blanco del archivo no se graba: que se vea el metal (en la negra no aplica)
        if (ink !== '#e9e9ea' && ink !== '#f4f4f4') im.style.mixBlendMode = 'multiply';
        gg.appendChild(im);
        return gg;
      }
      if (logoURL) return el('image', { href: logoURL, x: x, y: y, width: w, height: h, preserveAspectRatio: 'xMidYMid meet' });
      var g = el('g', { 'font-family': FONTS.arial, 'font-weight': '700', fill: ink, 'text-anchor': 'middle', opacity: '.55' });
      var r = Math.min(w, h) / 2, cx = x + w / 2, cy = y + h / 2;
      // Caja ancha (office sign): rectángulo punteado en vez de círculo, para que se vea el área real
      if (w > h * 1.2) g.appendChild(el('rect', { x: x + 1, y: y + 1, width: w - 2, height: h - 2, rx: 6, fill: 'none', stroke: ink, 'stroke-width': '1.6', 'stroke-dasharray': '3 3' }));
      else g.appendChild(el('circle', { cx: cx, cy: cy, r: r - 1, fill: 'none', stroke: ink, 'stroke-width': '1.6', 'stroke-dasharray': '3 3' }));
      // Zona muy ancha (logo arriba del name tag 1.5"): el aviso en una sola línea, a su tamaño
      if (w > h * 2.5) {
        var f1 = Math.min(h * 0.36, w * 0.075);
        g.appendChild(el('text', { x: cx, y: cy + f1 * 0.36, 'font-size': f1.toFixed(1), 'letter-spacing': (f1 * 0.06).toFixed(1) }, 'YOUR LOGO HERE'));
        return g;
      }
      var fs = r * 0.36;
      ['YOUR', 'LOGO', 'HERE'].forEach(function (s, i) {
        g.appendChild(el('text', { x: cx, y: cy + (i - 1) * fs * 1.05 + fs * 0.35, 'font-size': fs.toFixed(1) }, s));
      });
      return g;
    }

    function render() {
      if (!stage) return;
      ldrag = null;
      var color = (opt(/colou?r/i) || 'Silver').toLowerCase();
      var key = /gold/.test(color) ? 'gold' : /black/.test(color) ? 'black' : /white/.test(color) ? 'white' : 'silver';
      var tall = /1\.5/.test(opt(/size/i));
      var W = 330, H = cfg.shape === 'window' ? 118 : tall ? 165 : 110;
      // Placa de oficina 8" x 2" (4:1) o 10" x 2" (5:1), esquinas casi rectas
      // Placa de oficina: proporción real de la ranura del taller (200,1 × 50,8 / 251,3 × 50,8 mm)
      var pmm = PLATE_MM[/10\s*"?\s*x/.test(opt(/size/i)) ? 10 : 8];
      if (cfg.shape === 'plate') { W = 340; H = W * pmm[1] / pmm[0]; }
      var VW = 360, VH = H + 30, X = (VW - W) / 2, Y = 15;
      var m = METAL[key];
      var ink = key === 'black' ? (cfg.finish === 'engraved' ? '#e9e9ea' : '#f4f4f4') : '#1d1d1f';
      logoURL = files[cfg.shape !== 'window' && layout() === 7 ? 'design' : 'logo'][1];
      var svg = el('svg', { viewBox: '0 0 ' + VW + ' ' + VH, role: 'img', focusable: 'false' });
      var gid = 'fgpnt' + Math.random().toString(36).slice(2, 7);
      var defs = el('defs', {});
      var lg = el('linearGradient', { id: gid, x1: '0', y1: '0', x2: '1', y2: '1' });
      lg.appendChild(el('stop', { offset: '0', 'stop-color': m[0] }));
      lg.appendChild(el('stop', { offset: '.55', 'stop-color': m[1] }));
      lg.appendChild(el('stop', { offset: '1', 'stop-color': m[0] }));
      defs.appendChild(lg);
      svg.appendChild(defs);
      var plate = cfg.shape === 'oval'
        ? el('ellipse', { cx: VW / 2, cy: Y + H / 2, rx: W / 2, ry: H / 2 })
        : el('rect', { x: X, y: Y, width: W, height: H, rx: cfg.shape === 'plate' ? 3 : 10 });
      plate.setAttribute('fill', 'url(#' + gid + ')');
      plate.setAttribute('stroke', m[2]);
      plate.setAttribute('stroke-width', '1.5');
      svg.appendChild(plate);
      stage.innerHTML = '';
      stage.appendChild(svg);   // en el DOM antes de medir el texto

      var fits = [];
      function lines(arr, x, cx, top, bot, maxW, font, anchor) {
        // arr = [[texto, esLinea1]]; la línea 1 más grande y en negrita (como el listado)
        var show = arr.filter(function (a) { return a[0]; });
        if (!show.length) show = [['Your Name', true, true]];
        // Placa: línea 2 al 62 % salvo "All lines the same size" (Text style)
        var styled = cfg.shape !== 'plate' && !!document.querySelector('.fgnt select[name="properties[Text style]"]');
        var BIG = cfg.shape === 'plate' ? (plateSame() ? 1 : 1.6) : styled ? (plateSame() ? 1 : 1.25) : 1.35;
        var units = show.reduce(function (s, a) { return s + (a[1] ? BIG : 1); }, 0);
        var fs = Math.min((bot - top) / (units * 1.12), cfg.shape === 'plate' ? 40 : 30);
        var g = el('g', { 'font-family': FONTS[font], fill: ink, 'text-anchor': anchor || 'middle' });
        if (font === 'monotype') g.setAttribute('font-style', 'italic');
        svg.appendChild(g);
        var y = top + ((bot - top) - units * fs * 1.12) / 2;
        show.forEach(function (a) {
          var s = fs * (a[1] ? BIG : 1);
          y += s * 1.12;
          var tx = el('text', { x: anchor === 'start' ? x : cx, y: (y - s * 0.28).toFixed(1), 'font-size': s.toFixed(1), 'font-weight': (cfg.shape !== 'plate' && !styled && (a[1] || font === 'monotype')) || ((cfg.shape === 'plate' || styled) && a[1] && plateBold()) ? '700' : '400' }, a[0]);
          if (a[2]) tx.setAttribute('opacity', '.35');
          g.appendChild(tx);
          fits.push([tx, maxW]);
        });
      }

      var pad = cfg.shape === 'oval' ? W * 0.13 : 14;
      if (cfg.shape === 'window') {
        // Ventana abajo con el inserto del nombre; arriba el logo (y Line 1 con "Logo + text")
        var winH = H * 0.44, winY = Y + H - winH - 10;
        svg.appendChild(el('rect', { x: X + 16, y: winY, width: W - 32, height: winH, rx: 4, fill: '#fbfbfa', stroke: m[2], 'stroke-width': '1.2' }));
        var nm = el('text', { x: VW / 2, y: winY + winH * 0.68, 'font-family': FONTS.arial, 'font-size': (winH * 0.5).toFixed(1), fill: '#9a9a9a', 'text-anchor': 'middle' }, 'YOUR NAME');
        svg.appendChild(nm);
        var topH = winY - Y - 12, ly = Y + 7;
        var withText = /logo\s*\+\s*text/i.test(opt(/style/i));
        var l1 = lineVal(1);
        if (withText) {
          var lw = W * 0.42;
          svg.appendChild(logoNode(X + 18, ly, lw - 10, topH, ink));
          svg.appendChild(el('line', { x1: X + lw + 16, y1: ly + 4, x2: X + lw + 16, y2: ly + topH - 4, stroke: ink, 'stroke-width': '1.4', opacity: '.7' }));
          var tt = el('text', { x: X + lw + 28, y: ly + topH * 0.68, 'font-family': FONTS.arial, 'font-weight': '700', 'font-size': (topH * 0.5).toFixed(1), fill: ink }, l1 || 'TITLE');
          if (!l1) tt.setAttribute('opacity', '.35');
          svg.appendChild(tt);
          fits.push([tt, W - lw - 46]);
        } else {
          svg.appendChild(logoNode(X + W * 0.2, ly, W * 0.6, topH, ink));
        }
      } else {
        var L = layout();
        var font = L >= 4 && L <= 6 ? 'monotype' : 'arial';
        var arr = [[lineVal(1), true], [lineVal(2), false], [lineVal(3), false]];
        if (L === 7) {
          if (logoURL) {
            var cp = 'fgpntc' + gid;
            var clip = el('clipPath', { id: cp });
            clip.appendChild(plate.cloneNode());
            defs.appendChild(clip);
            var img = logoNode(X + 4, Y + 4, W - 8, H - 8, ink);
            img.setAttribute('clip-path', 'url(#' + cp + ')');
            svg.appendChild(img);
          } else {
            lines([['Your own design', true, true]], 0, VW / 2, Y + 10, Y + H - 10, W - pad * 2, 'arial');
          }
        } else if (cfg.shape === 'plate' && (L === 2 || L === 5)) {
          // Office sign (27-oct-2026, María): MISMA geometría que etsy/office_sign.py — márgenes
          // 9 × 6,5 mm, logo al alto útil sin pasar de un tercio del ancho, recortado a la tinta,
          // aire de 0,14 × alto y el texto centrado en lo que queda. El cliente puede achicarlo
          // (Logo size) y moverlo dentro de su zona (Logo position); el texto no se mueve.
          var u = W / pmm[0], aw = (pmm[0] - 2 * PL_MX) * u, ah = (pmm[1] - 2 * PL_MY) * u;
          var izq = X + PL_MX * u, top = Y + PL_MY * u, crop = files.logo[2];
          var zw = aw * 0.33, lw = zw, lh = ah;
          if (logoURL && crop) {
            var k0 = Math.min(ah / crop.h, zw / crop.w);
            zw = crop.w * k0; lw = zw * lzoom; lh = crop.h * k0 * lzoom;
          }
          var pos = lpos || [0, 0.5];
          var lxp = izq + pos[0] * (zw - lw), lyp = top + pos[1] * (ah - lh);
          var ln = logoNode(lxp, lyp, lw, lh, ink, crop);
          if (logoURL && crop) { ln.setAttribute('class', 'fgp-nt__logo'); ln.style.cursor = 'move'; ln.style.touchAction = 'none'; }
          svg.appendChild(ln);
          ldrag = { fx: zw - lw, fy: ah - lh, def: [0, 0.5], scale: VW / (stage.getBoundingClientRect().width || VW) };
          var tx0 = izq + zw + pmm[1] * 0.14 * u, tw = izq + aw - tx0;
          lines(arr, tx0, tx0 + tw / 2, top + ah * 0.07, top + ah * 0.93, tw, font);
        } else if (ntV2() && (L === 2 || L === 5 || L === 3 || L === 6)) {
          var g = NT_GEOM[tall ? 15 : 1], u = W / 76.2, bw = g.bw * u, bh = g.bh * u;
          var bx = X + (W - bw) / 2, by = Y + (H - bh) / 2, crop = files.logo[2];
          var isTop = (L === 3 || L === 6) && g.top;
          var asp = logoURL && crop ? crop.w / crop.h : 1.4;
          var zx, zy, zw, zh, k, tx0, tw, ty, th;
          if (isTop) {
            // Zona fija y ancha (no la caja del logo): el logo entra ahí y se mueve también a lo ancho
            zh = bh * g.top.h; zw = bw * g.top.w; k = Math.min(zh, zw / asp);
            zx = bx + (bw - zw) / 2; zy = by;
            tx0 = bx; tw = bw; ty = by + zh + g.top.gap * u; th = by + bh - ty;
          } else {
            zh = bh; k = Math.min(bh, bw * g.left.w / asp); zw = asp * k;
            zx = bx; zy = by;
            tx0 = bx + zw + g.left.gap * u; tw = bx + bw - tx0; ty = by + bh * 0.04; th = bh * 0.92;
          }
          var def = isTop ? [0.5, 0.5] : [0, 0.5], pos = lpos || def;
          // Logo al 100 % = asp·k × k (a la izquierda asp·k ya es el ancho de la zona); sin
          // imagen se dibuja la zona entera punteada
          var lw = zw, lh = zh;
          if (logoURL && crop) { lw = asp * k * lzoom; lh = k * lzoom; }
          var ln = logoNode(zx + pos[0] * (zw - lw), zy + pos[1] * (zh - lh), lw, lh, ink, crop);
          if (logoURL && crop) { ln.setAttribute('class', 'fgp-nt__logo'); ln.style.cursor = 'move'; ln.style.touchAction = 'none'; }
          svg.appendChild(ln);
          ldrag = { fx: zw - lw, fy: zh - lh, def: def, scale: VW / (stage.getBoundingClientRect().width || VW) };
          // Una sola línea no pasa del 62 % del alto de su caja (como el agente)
          var nl = arr.filter(function (a) { return a[0]; }).length || 1;
          if (nl === 1) { ty += th * 0.19; th *= 0.62; }
          lines(arr, tx0, tx0 + tw / 2, ty, ty + th, tw, font);
        } else if (L === 2 || L === 5) {
          var s = H - 24, lx = X + pad + (cfg.shape === 'oval' ? 4 : 0);
          svg.appendChild(logoNode(lx, Y + 12, s, s, ink));
          var tx0 = lx + s + 10, tw = X + W - pad - tx0;
          lines(arr, tx0, tx0 + tw / 2, Y + 8, Y + H - 8, tw, font);
        } else if (L === 3 || L === 6) {
          var lh = H * 0.32;
          svg.appendChild(logoNode(VW / 2 - lh / 2, Y + 8, lh, lh, ink));
          lines(arr, 0, VW / 2, Y + lh + 10, Y + H - 8, W - pad * 2, font);
        } else {
          lines(arr, 0, VW / 2, Y + 8, Y + H - 8, W - pad * 2, font);
        }
      }
      fits.forEach(function (f) { fit(f[0], f[1]); });
      syncLogoCtl();
    }
    function later() { clearTimeout(t); t = setTimeout(render, 30); setTimeout(render, 300); }

    // PDF/AI/EPS no se pueden pintar: queda el círculo "YOUR LOGO HERE"
    function setLogo(input, kind) {
      var f = (input.files && input.files[0]) || null, slot = files[kind];
      if (f === slot[0]) return;
      if (slot[1]) URL.revokeObjectURL(slot[1]);
      slot[0] = f;
      slot[1] = f && /^image\/(png|jpe?g|gif|webp|svg\+xml)$/i.test(f.type) ? URL.createObjectURL(f) : null;
      slot[2] = null;
      // Volver a tamaño/posición de siempre solo si es OTRO archivo (Globo re-dispara el change)
      var fk = f ? f.name + '|' + f.size + '|' + f.lastModified : '';
      if (kind === 'logo' && fk !== lkey) { lzoom = 1; lpos = null; lkey = fk; }
      if (slot[1]) inkBox(slot[1], function (c) { if (slot[0] === f) { slot[2] = c; later(); } });
      later();
    }
    // Recuadro de lo que se graba: ni transparente ni casi blanco (como lo recorta el agente
    // al vectorizar). En coordenadas de la imagen original.
    function inkBox(url, done) {
      var im = new Image();
      im.onload = function () {
        var iw = im.naturalWidth || 300, ih = im.naturalHeight || 300, k = Math.min(1, 500 / Math.max(iw, ih));
        var w = Math.max(1, Math.round(iw * k)), h = Math.max(1, Math.round(ih * k));
        var full = { x: 0, y: 0, w: iw, h: ih, iw: iw, ih: ih };
        try {
          var c = document.createElement('canvas'); c.width = w; c.height = h;
          var g = c.getContext('2d'); g.drawImage(im, 0, 0, w, h);
          var d = g.getImageData(0, 0, w, h).data, x0 = w, y0 = h, x1 = -1, y1 = -1;
          for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
            var i = (y * w + x) * 4;
            if (d[i + 3] > 24 && !(d[i] > 235 && d[i + 1] > 235 && d[i + 2] > 235)) {
              if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y;
            }
          }
          if (x1 < 0) return done(full);
          done({ x: x0 / k, y: y0 / k, w: (x1 - x0 + 1) / k, h: (y1 - y0 + 1) / k, iw: iw, ih: ih });
        } catch (e) { done(full); }
      };
      im.onerror = function () { done(null); };
      im.src = url;
    }
    // Controles del logo (office sign con Text+Logo y una imagen que se puede pintar) y lo que
    // viaja en la orden: solo si el cliente cambió algo (sin cambios = el agente hace lo de siempre).
    function syncLogoCtl() {
      if (!ctl) return;
      var on = !!(ldrag && files.logo[1] && files.logo[2]);
      ctl.hidden = !on;
      ctl.querySelector('input[type=range]').value = Math.round(lzoom * 100);
      ctl.querySelector('.fgp-nt__zv').textContent = Math.round(lzoom * 100) + '%';
      var p = lpos || (ldrag && ldrag.def) || [0, 0.5], d0 = (ldrag && ldrag.def) || [0, 0.5];
      var moved = on && (lzoom < 0.995 || Math.abs(p[0] - d0[0]) > 0.005 || Math.abs(p[1] - d0[1]) > 0.005);
      if (moved) {
        hSize.name = 'properties[Logo size]'; hSize.value = Math.round(lzoom * 100) + '%';
        hPos.name = 'properties[Logo position]';
        hPos.value = 'left ' + Math.round(p[0] * 100) + '%, top ' + Math.round(p[1] * 100) + '%';
      } else { hSize.removeAttribute('name'); hPos.removeAttribute('name'); }
    }

    // Barra "Logo size" + arrastrar el logo dentro de su zona (office sign, 27-oct-2026, María)
    function buildLogoCtl() {
      ctl = document.createElement('div');
      ctl.className = 'fgp-nt__ctl';
      ctl.hidden = true;
      ctl.style.cssText = 'margin:10px 4px 0;font-size:13px;letter-spacing:.02em';
      ctl.innerHTML = '<label style="display:flex;align-items:center;gap:10px">' +
        '<span style="white-space:nowrap;font-weight:600">Logo size</span>' +
        '<input type="range" min="50" max="100" step="1" style="flex:1;min-width:0" aria-label="Logo size">' +
        '<span class="fgp-nt__zv" style="min-width:38px;text-align:right">100%</span></label>' +
        '<p style="margin:6px 0 0;opacity:.75">Drag the logo on the preview to move it. ' +
        '<button type="button" class="fgp-nt__reset" style="background:none;border:0;padding:0;text-decoration:underline;cursor:pointer;font:inherit;color:inherit">Reset</button></p>' +
        '<input type="hidden" class="fgp-nt__hs"><input type="hidden" class="fgp-nt__hp">';
      var fid = form.getAttribute('id');
      hSize = ctl.querySelector('.fgp-nt__hs'); hPos = ctl.querySelector('.fgp-nt__hp');
      if (fid) { hSize.setAttribute('form', fid); hPos.setAttribute('form', fid); }
      ctl.querySelector('input[type=range]').addEventListener('input', function (e) {
        e.stopPropagation();
        lzoom = Math.max(0.5, Math.min(1, +this.value / 100));
        render();
      });
      ctl.querySelector('.fgp-nt__reset').addEventListener('click', function () { lzoom = 1; lpos = null; render(); });
      stage.parentNode.insertBefore(ctl, stage.nextSibling);
      var drag = null;
      stage.addEventListener('pointerdown', function (e) {
        if (!ldrag || !e.target.closest || !e.target.closest('.fgp-nt__logo')) return;
        e.preventDefault();
        drag = { x: e.clientX, y: e.clientY, p: (lpos || ldrag.def).slice() };
      });
      window.addEventListener('pointermove', function (e) {
        if (!drag || !ldrag) return;
        var fx = ldrag.fx, fy = ldrag.fy;
        var nx = fx > 0.5 ? drag.p[0] + (e.clientX - drag.x) * ldrag.scale / fx : drag.p[0];
        var ny = fy > 0.5 ? drag.p[1] + (e.clientY - drag.y) * ldrag.scale / fy : drag.p[1];
        lpos = [Math.max(0, Math.min(1, nx)), Math.max(0, Math.min(1, ny))];
        render();
      });
      window.addEventListener('pointerup', function () { drag = null; });
    }

    function build() {
      if (box && document.body.contains(box)) return;
      var anchor = document.querySelector('.gpo-app') || document.querySelector('.fgp-field');
      if (!anchor) return;
      box = document.createElement('div');
      box.className = 'fgp-nt';
      var what = cfg.shape === 'plate' ? 'name plate' : 'name tag';
      box.innerHTML = '<p class="fgp-nt__title">Your ' + what + ' preview</p><div class="fgp-nt__stage" aria-hidden="true"></div>' +
        '<p class="fgp-nt__note">Preview is approximate. Your ' + (cfg.shape === 'plate' ? 'plate' : 'tag') + ' is made exactly as typed.</p>';
      stage = box.querySelector('.fgp-nt__stage');
      if (cfg.shape === 'plate' || ntV2()) buildLogoCtl();
      // Office sign (27-oct-2026, María): primero el menú "Design Option" y debajo la vista
      // previa, para que se vea cambiar al elegir. Los name tags siguen con la vista arriba.
      var dsel = (cfg.shape === 'plate' || ntV2()) && document.querySelector('.fgnt select[name="properties[Design Option]"]');
      var dopt = dsel && dsel.closest('.gpo-element');
      if (dopt) dopt.parentNode.insertBefore(box, dopt.nextSibling);
      else anchor.parentNode.insertBefore(box, anchor);
      // La foto fija del layout elegido (design_previews) sobra con el dibujo en vivo
      document.body.classList.add('fgp-has-nt');
      render();
    }
    document.addEventListener('input', later, true);
    document.addEventListener('change', function (e) {
      var i = e.target;
      // Los campos fg_field van fuera del <form> (atributo form=), por eso no se filtra por form
      if (i && i.type === 'file') {
        var lab = ((i.closest('.gpo-element, .fgp-field') || {}).textContent || '') + ' ' + (i.name || '');
        if (/own design|your design/i.test(lab)) setLogo(i, 'design');
        else if (/logo|design/i.test(lab)) setLogo(i, 'logo');
      }
      later();
    }, true);
    // Globo pinta tarde (y repinta al cambiar el layout): se reintenta y se observa el DOM
    [600, 1500, 3000, 6000].forEach(function (ms) { setTimeout(build, ms); });
    if (window.MutationObserver) {
      var mo = null;
      new MutationObserver(function () { clearTimeout(mo); mo = setTimeout(function () { build(); later(); }, 150); })
        .observe(form, { childList: true, subtree: true });
    }
  }

  // ---------- Campos propios en vez de Globo (name tags, 23-oct-2026) ----------
  // Solo si snippets/fg-nt-fields.liquid imprimió <script id="fgp-fields"> (ese snippet también
  // saca el producto del mapa de Globo). Pinta los campos donde iba Globo, arriba del botón, y
  // cada uno viaja como properties[<prop>] con el nombre que mandaba Globo. Las clases gpo-app /
  // gpo-element / gpo-label se conservan a propósito: initTeam, initNames y la vista previa del
  // name tag buscan los campos por ahí y siguen funcionando sin cambios.
  //   tipos: select, text (max = contador), textarea, file (sube a cdn.shopify.com al agregar)
  //   show_if / hide_if: {"<prop>": [valores]} — oculto = deshabilitado, no viaja en la orden.
  //   opción con cargo: {"v": "Text+Logo", "addon": <variant id>, "price": "2.00"} → al agregar,
  //   antes del producto entra una línea de esa variante (misma cantidad), como hacía Globo. Hoy
  //   son las variantes del producto oculto de cargos de Globo; el poller las ignora por product id.
  function initOwnFields() {
    var tag = document.getElementById('fgp-fields');
    if (!tag) return;
    var cfg;
    try { cfg = JSON.parse(tag.textContent); } catch (e) { return; }
    var fields = cfg.sets[cfg.products[tag.getAttribute('data-pid')]];
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!fields || !form) return;
    var wrap = form.querySelector('.product-form__buttons-wrapper') || form;
    var app = document.createElement('div');
    app.className = 'gpo-app fgnt';
    var els = [];

    fields.forEach(function (f, i) {
      var id = 'fgnt-' + i;
      var el = document.createElement('div');
      el.className = 'gpo-element fgnt-el';
      var lab = document.createElement('label');
      lab.className = 'gpo-label fgnt-label' + (f.required ? ' required' : '');
      lab.htmlFor = id;
      lab.textContent = f.label;
      if (f.required) { var s = document.createElement('span'); s.className = 'fgnt-req'; s.textContent = ' *'; lab.appendChild(s); }
      el.appendChild(lab);
      if (f.help) { var h = document.createElement('p'); h.className = 'gpo-helptext fgnt-help'; h.textContent = f.help; el.appendChild(h); }
      var inp;
      if (f.type === 'select') {
        inp = document.createElement('select');
        var o0 = document.createElement('option'); o0.value = ''; o0.textContent = f.placeholder || '-- Please select --';
        inp.appendChild(o0);
        if (f.default) o0.hidden = true;
        f.options.forEach(function (v) {
          var o = document.createElement('option');
          o.value = v.v || v;
          o.textContent = (v.v || v) + (v.price ? ' (+$' + v.price + ')' : '');
          if (v.addon) o.setAttribute('data-addon', v.addon);
          if (f.default && (v.v || v) === f.default) o.selected = true;
          inp.appendChild(o);
        });
      } else if (f.type === 'textarea') {
        inp = document.createElement('textarea'); inp.rows = 4;
      } else {
        inp = document.createElement('input');
        inp.type = f.type === 'file' ? 'file' : 'text';
        if (f.accept) inp.accept = f.accept;
        if (f.max) inp.maxLength = f.max;
        if (f.type !== 'file') inp.autocomplete = 'off';
      }
      if (f.placeholder && f.type !== 'select') inp.placeholder = f.placeholder;
      inp.id = id;
      inp.className = 'fgnt-input';
      inp.name = 'properties[' + f.prop + ']';
      el.appendChild(inp);
      if (f.max) {
        var c = document.createElement('p'); c.className = 'fgnt-count';
        var cnt = function () { c.textContent = inp.value.length + '/' + f.max + ' characters'; };
        inp.addEventListener('input', cnt); cnt();
        el.appendChild(c);
      }
      var er = document.createElement('p'); er.className = 'fgnt-err'; er.hidden = true;
      er.textContent = f.type === 'file' ? 'Please upload your file.' : f.type === 'select' ? 'Please choose an option.' : 'This field is required.';
      el.appendChild(er);
      inp.addEventListener('input', function () { el.classList.remove('is-missing'); er.hidden = true; });
      inp.addEventListener('change', function () { el.classList.remove('is-missing'); er.hidden = true; conds(); });
      app.appendChild(el);
      els.push({ f: f, el: el, inp: inp, er: er });
    });

    function val(prop) {
      var x = els.filter(function (e) { return e.f.prop === prop; })[0];
      return x && !x.inp.disabled ? x.inp.value : '';
    }
    // Opciones de la variante elegida ("Silver 1.5" x 3" - Pin Back"), para show_if_variant
    function variantText() {
      var t = [];
      document.querySelectorAll('variant-radios input:checked, variant-selects select, .product-form__input input[type=radio]:checked, .product-form__input select').forEach(function (i) { t.push(i.value); });
      return t.join(' | ');
    }
    function conds() {
      var vt = variantText();
      els.forEach(function (e) {
        var on = true;
        if (e.f.show_if_variant && vt.indexOf(e.f.show_if_variant) < 0) on = false;
        if (e.f.show_if) on = on && Object.keys(e.f.show_if).every(function (k) { return e.f.show_if[k].indexOf(val(k)) >= 0; });
        if (e.f.hide_if && Object.keys(e.f.hide_if).some(function (k) { return e.f.hide_if[k].indexOf(val(k)) >= 0; })) on = false;
        e.el.hidden = !on;
        e.inp.disabled = !on;
      });
    }
    conds();
    wrap.insertBefore(app, wrap.firstChild);
    // Cambiar la variante (tamaño) muestra u oculta los campos con show_if_variant
    if (els.some(function (e) { return e.f.show_if_variant; }))
      document.addEventListener('change', function (e) { if (!app.contains(e.target)) setTimeout(conds, 50); }, true);

    function valid() {
      var first = null;
      els.forEach(function (e) {
        // Oculto por condición, por la lista del equipo (fgp-team-hide) o el archivo de recurrentes
        if (!e.f.required || e.inp.disabled || e.el.offsetParent === null) return;
        var empty = e.f.type === 'file' ? !(e.inp.files && e.inp.files.length) : !e.inp.value.trim();
        e.el.classList.toggle('is-missing', empty);
        e.er.hidden = !empty;
        if (empty && !first) first = e;
      });
      if (first) { first.el.scrollIntoView({ behavior: 'smooth', block: 'center' }); try { first.inp.focus({ preventScroll: true }); } catch (x) {} }
      return !first;
    }
    function addons() {
      var out = [];
      els.forEach(function (e) {
        if (e.f.type !== 'select' || e.inp.disabled) return;
        var o = e.inp.options[e.inp.selectedIndex];
        if (o && o.getAttribute('data-addon')) out.push({ id: +o.getAttribute('data-addon'), opt: e.f.prop + ': ' + o.value });
      });
      return out;
    }
    function qty() {
      var q = document.querySelector('input[name="quantity"][form="' + form.getAttribute('id') + '"]') || form.querySelector('input[name="quantity"]');
      return Math.max(1, parseInt(q && q.value, 10) || 1);
    }
    function addAddons(list) {
      var title = ((document.querySelector('.product__title h1, h1') || {}).textContent || '').trim();
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: list.map(function (a) { return { id: a.id, quantity: qty(), properties: { _for: title, _option: a.opt } }; }) })
      }).then(function (r) { if (!r.ok) throw new Error('addon'); });
    }
    var adding = false;
    // En window (captura) para correr antes que el theme y los otros guardias de fg-pdp.js
    window.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('button[type=submit], .sticky-product-form__submit, .shopify-payment-button__button, .shopify-payment-button [role=button]');
      if (!b) return;
      var buyNow = !!b.closest('.shopify-payment-button');
      var bf = b.form || (b.closest && b.closest('form'));
      if (bf && bf !== form && !b.classList.contains('sticky-product-form__submit') && !buyNow) return;
      if (!valid()) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      var list = addons();
      if (!list.length || adding) return;
      e.preventDefault(); e.stopImmediatePropagation();
      adding = true;
      addAddons(list).then(function () {
        if (buyNow) {
          // "Buy it now" no pasa por el carrito: se agrega el producto también y se va al checkout
          return fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
            .then(function (r) { if (!r.ok) throw new Error('add'); location.href = '/checkout'; });
        }
        b.click();
      }).catch(function () {
        alert('Sorry, we could not add your item. Please try again.');
      }).then(function () { adding = false; });
    }, true);
    form.addEventListener('submit', function (e) { if (!valid()) { e.preventDefault(); e.stopImmediatePropagation(); } }, true);
    // Como Globo: los campos vacíos no viajan (si no, el carrito muestra "text-3:" vacío)
    form.addEventListener('formdata', function (e) {
      els.forEach(function (x) {
        var empty = x.f.type === 'file' ? !(x.inp.files && x.inp.files.length) : !x.inp.value.trim();
        if (!x.inp.disabled && empty) e.formData.delete(x.inp.name);
      });
    });
  }

  function init() {
    initOwnFields();
    initDesignPreview();
    initNameTagPreview();
    initOrientationPreview();
    initTeam();
    initNames();
    initBack();
    initProof();
    document.querySelectorAll('.product__description').forEach(initDescription);
    document.querySelectorAll('[data-fgp-ship]').forEach(initShip);
    document.querySelectorAll('[data-fgp-slider]').forEach(initSlider);

    // Oferta: abre el popup de Klaviyo (Email & SMS Popup, 10% de la primera compra)
    document.querySelectorAll('[data-fgp-form]').forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-fgp-form');
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', id]);
      });
    });

    // Estrellas → baja a las reseñas (Judge.me o Klaviyo Reviews, la que esté)
    document.querySelectorAll('[data-fgp-scroll]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.querySelector('.jdgm-review-widget, .jdgm-widget.jdgm-review-widget, #klaviyo-reviews-all, [data-id="klaviyo-reviews"], .klaviyo-star-rating-widget');
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    // Videos de clientes: tocar para reproducir
    document.querySelectorAll('.fgps-ugc__card video').forEach(function (v) {
      var card = v.closest('.fgps-ugc__card');
      card.addEventListener('click', function () {
        if (v.paused) {
          document.querySelectorAll('.fgps-ugc__card video').forEach(function (o) { if (o !== v) { o.pause(); o.closest('.fgps-ugc__card').classList.remove('is-playing'); } });
          v.muted = false; v.play(); card.classList.add('is-playing');
        } else { v.pause(); card.classList.remove('is-playing'); }
      });
    });

    initRealOrders();
  }

  // Real orders: los videos del carrusel corren sin sonido; tocar uno prende/apaga
  // el audio (y pausa el carrusel mientras suena para que no se vaya de la vista).
  function initRealOrders() {
    document.querySelectorAll('.fgps-ro__item--video').forEach(function (card) {
      var v = card.querySelector('video'); if (!v) return;
      card.addEventListener('click', function () {
        var on = v.muted;
        document.querySelectorAll('.fgps-ro__item--video').forEach(function (o) {
          var ov = o.querySelector('video'); if (ov && ov !== v) { ov.muted = true; o.classList.remove('is-sound'); }
        });
        v.muted = !on; card.classList.toggle('is-sound', on);
        var m = card.closest('.fgps-ro__marquee'); if (m) m.classList.toggle('is-paused', on);
        if (v.paused) v.play();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
